module.exports = __webpack_public_path__ + "static/media/DSC04241.8a135d59.jpg";